import { CaretDownFilled } from '@ant-design/icons';
import { Button, Popover as PopoverAntd } from 'antd';
import cx from 'classnames';
import React, { ReactNode, useState } from 'react';
import { Divider } from '../Divider/Divider';
import styles from './popover.module.scss';

type Props = {
	title: string;
	buttonIcon?: ReactNode;
	disabled?: boolean;
	isActive?: boolean;
	id?: string;
	showFooter?: boolean;
	buttonClassName?: string;
	onApplyAction?: () => void;
	onResetAction?: () => void;
	children?: React.ReactNode;
};

const Popover: React.FC<Props> = ({ id, buttonIcon, title, disabled, showFooter, isActive, buttonClassName, onApplyAction, onResetAction, children }) => {
	//#region State Management Variables
	const [open, setOpen] = useState<boolean>(false);
	const [isActionActive, setIsActionActive] = useState<boolean>(false);
	//#endregion

	const handleOpenChange = (isOpen: boolean) => {
		setOpen(isOpen);
	};

	const handleOnApplyAction = () => {
		setIsActionActive(true);
		onApplyAction?.();
	};

	const handleOnResetAction = () => {
		setIsActionActive(false);
		onResetAction?.();
	};

	return (
		<PopoverAntd
			id={id}
			content={
				<div>
					{children}
					{showFooter && (
						<>
							<Divider />
							<div className={styles.footer}>
								<Button onClick={handleOnResetAction}>{_('Reset')}</Button>
								<Button type='primary' onClick={handleOnApplyAction}>
									{_('Apply')}
								</Button>
							</div>
						</>
					)}
				</div>
			}
			placement='bottom'
			open={open}
			onOpenChange={handleOpenChange}>
			<Button
				disabled={disabled}
				icon={buttonIcon ?? <span />}
				className={cx(styles.popOverButton, buttonClassName)}
				type={isActionActive || isActive ? 'primary' : 'default'}>
				<span>{_(title)}</span>
				<CaretDownFilled className={styles.popOverDownArrow} />
			</Button>
		</PopoverAntd>
	);
};

export { Popover };
